module.exports = __webpack_public_path__ + "static/media/cozy9109.4f1b6abb.jpg";